import { createFileRoute, useParams } from "@tanstack/react-router";
import { z } from "zod";
import { ContactDetailPage } from "@/components/crm/ContactDetailPage";

export const Route = createFileRoute("/user/_layout/crm/contacts_/$id")({
  validateSearch: z.object({ tab: z.string().min(1).catch("general").default("general") }),
  component: UserContactDetail,
});

function UserContactDetail() {
  const { id } = useParams({ from: "/user/_layout/crm/contacts_/$id" });
  const { tab } = Route.useSearch();
  return <ContactDetailPage contactId={id} role="user" activeTab={tab} />;
}
